import { FC } from 'react';
import { Box, Modal } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';

import { ContactForm } from '../ContactForm';

interface IModal {
  isOpen: boolean;
  isSubmitting: boolean;
  onSubmit: (data) => void;
  onCancel: () => void;
  handleDeleteButton: () => void;
  contact: RidersContactForm;
}

export const EditModal: FC<IModal> = ({ isOpen, onSubmit, onCancel, handleDeleteButton, contact, isSubmitting }) => (
  <Modal open={isOpen}>
    <Modal.Title>Edit Contact</Modal.Title>
    <Modal.Content>
      <ContactForm contact={contact} onSubmit={onSubmit} onCancel={onCancel} />
    </Modal.Content>
    <Modal.Actions>
      <Box display="flex" flex="1" justifyContent="space-between">
        <Button color="destructive" onClick={handleDeleteButton} style={{ flexGrow: 0 }}>
          Delete
        </Button>
        <div>
          <Button color="tertiary" autoFocus onClick={onCancel} loading={isSubmitting}>
            Cancel
          </Button>
          <Button color="primary" type="submit" form={'contact'} loading={isSubmitting} style={{ marginLeft: '8px' }}>
            {isSubmitting ? 'Saving...' : 'Save'}
          </Button>
        </div>
      </Box>
    </Modal.Actions>
  </Modal>
);
